/*
 * @Author: zhao - 🍉
 * @Date: 2021-12-17 18:04:35
 * @LastEditTime: 2021-12-17 18:06:43
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/utils/validate.js
 */
import moment from "moment";
/**
 * 检查手机号
 *
 * @export
 * @param {string} [phone='']
 * @returns {boolean}
 * @description 规则: 【第一位为1，第二位3-9，共11位】
 */
 export function isPhone(phone = '') {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(phone)
}

/**
 * 是否有效的日期区间
 *
 * @export {Function}
 * @param {Date} startDate 开始日期
 * @param {Date} endDate 结束日期
 * @returns {Boolean} boolean
 */
export function isDateRange(startDate, endDate) {
  return moment(startDate).isBefore(endDate)
}


// WEBPACK FOOTER //
// ./src/utils/validate.js